// Timeout pour les recherches d'�talissement en milliseconde.
export const TIMEOUT_ETABLISSEMENT = 500;